import { render, staticRenderFns } from "./page-section-primary.vue?vue&type=template&id=e4c6c5a4&scoped=true&"
import script from "./page-section-primary.vue?vue&type=script&lang=js&"
export * from "./page-section-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c6c5a4",
  null
  
)

export default component.exports